import { Badge, Box, Button, Divider, Icon, Menu, Stack } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Link, matchPath, useNavigate } from "react-router-dom";
import { MenuDefinition } from "../../constants/MenuConstants";
import { IntegrationContext } from "../../contexts/IntegrationContext";
import AppBarSubMenuItem from "./AppBarSubMenuItem";

export default function AppBarMenuItem(props: { menuItem: MenuDefinition }) {
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [badgeCount, setBadgeCount] = useState<number | string | null>(null);
    const open = Boolean(anchorEl);

    const integrationContext = useContext(IntegrationContext);

    useEffect(() => {
        if (integrationContext.badgeNeedsRefresh) {
            getBadgeCountIfNeeded();
        }
    }, [integrationContext.badgeNeedsRefresh]);

    const getBadgeCountIfNeeded = async () => {
        if (props.menuItem.badgeCountResolver) {
            const result = await props.menuItem.badgeCountResolver();
            setBadgeCount(result);
            integrationContext.onBadgeFetched();
        }
    };

    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const isMatch = matchPath(window.location.pathname, props.menuItem.url);

    if ((props.menuItem.children?.length ?? 0) > 0) {
        const anyChildMath = props.menuItem.children!.some((i) => {
            return matchPath(window.location.pathname, i.url);
        });

        return (
            <>
                <Button
                    onClick={openMenu}
                    endIcon={<Icon>keyboard_arrow_down</Icon>}
                    sx={{
                        minWidth: 0,
                        color: anyChildMath ? "primary" : "text.secondary",
                    }}
                >
                    {props.menuItem.title}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    MenuListProps={{ sx: { py: 0 } }}
                    onClose={handleClose}
                >
                    <Stack divider={<Divider />}>
                        {props.menuItem.children!.map((c) => {
                            return (
                                <AppBarSubMenuItem
                                    key={c.title}
                                    menuItem={c}
                                    handleCloseMenu={handleClose}
                                />
                            );
                        })}
                    </Stack>
                </Menu>
            </>
        );
    }

    return (
        <Link to={props.menuItem.url}>
            <Button
                sx={{
                    minWidth: 0,
                    color: isMatch ? "primary" : "text.secondary",
                }}
            >
                <Badge
                    sx={{ p: 0.3 }}
                    badgeContent={
                        badgeCount ? (
                            <Box sx={{ fontFamily: "system-ui !important" }}>
                                {badgeCount}
                            </Box>
                        ) : null
                    }
                    color="error"
                >
                    {props.menuItem.title}
                </Badge>
            </Button>
        </Link>
    );
}
